import React, { forwardRef } from 'react';
import { Toast } from 'zarm';
import styled from 'styled-components';
import session from '@/store/session';
import { fetchFileById } from '@/services/supervision';
import { isPreviewMode } from '@/utils/tool';
import Gs from '@/Gs';
import './index.less';
const TabList = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    imgUrl,
    pdfUrl
  } = Gs.config;
  const {
    list = [],
    tabValue,
    noPopUp = false
  } = props;

  const gotoUrl = (url, type) => {
    if (isPreviewMode()) {
      return;
    }

    if (!noPopUp) {
      session.set('supervisionPopupShow', true);
      session.set('supervisionPopupShowTab', tabValue);
    }

    if (type === 'url') {
      window.location.href = url;
      return;
    }

    const link = url && url.replace(/^http:/, 'https:'); //   const { from, tenantFrom } = getQueryParam();
    //   const qFrom = tenantFrom || from || '';

    let href = link;

    if (typeof link === 'string' && link.includes('pdf')) {
      href = `${pdfUrl}?file=${encodeURIComponent(link)}`;
    }

    if (typeof link === 'string' && (link.includes('jpg') || link.includes('png') || link.includes('gif') || link.includes('svg') || link.includes('webp') || link.includes('bmp'))) {
      href = `${imgUrl}?path=${link}`;
    }

    window.location.href = href;
  };

  const fetchFile = (fileId, fileType) => {
    fetchFileById({
      id: fileId
    }).then(res => {
      const {
        message,
        success,
        result = {}
      } = res;

      if (!success) {
        // eslint-disable-next-line no-undef
        Toast.show(message || '网络异常，请稍后重试');
      } else {
        const {
          content,
          type
        } = result;
        gotoUrl(content, type);
      }
    });
  };

  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement("div", {
    className: "c-tabList-com",
    ref: ref
  }, list && list.map(item => {
    if (item.relation === 'files') {
      return item.files.map(fileItem => {
        return /*#__PURE__*/React.createElement("div", {
          onClick: () => {
            fetchFile(fileItem.id, fileItem.type);
          },
          className: "item"
        }, /*#__PURE__*/React.createElement("span", null, fileItem.name));
      });
    }

    if (item.relation === 'clause') {
      return item.clause.map(fileItem => {
        return /*#__PURE__*/React.createElement("div", {
          "data-href": fileItem.url,
          onClick: () => {
            gotoUrl(fileItem.url);
          },
          className: "item"
        }, /*#__PURE__*/React.createElement("span", null, fileItem.title));
      });
    }

    return null;
  })));
});
export default TabList;
const Wrapper = styled.div`
  & .c-tabList-com {
    padding-bottom: 110px;
  }
`;